/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const CommandFactory = require('./CommandFactory');
const SetPlotDataCommand = require('./SetPlotDataCommand');
const SetChartFormulaCommand = require('./SetChartFormulaCommand');
const SetSheetCellsCommand = require('./SetSheetCellsCommand');
const SetCellsCommand = require('./SetCellsCommand');
const SetTreeDataCommand = require('./SetTreeDataCommand');
const SetTreeItemDataCommand = require('./SetTreeItemDataCommand');
const SetTreeItemDepthCommand = require('./SetTreeItemDepthCommand');
const SetTreeItemDisabledCommand = require('./SetTreeItemDisabledCommand');
const SetTreeShowDepthCommand = require('./SetTreeShowDepthCommand');
const SetTreeItemShowDepthCommand = require('./SetTreeItemShowDepthCommand');
const SetTreeItemExpandFlagCommand = require('./SetTreeItemExpandFlagCommand');
const SetTreeItemCheckedFlagCommand = require('./SetTreeItemCheckedFlagCommand');
const AddTreeItemCommand = require('./AddTreeItemCommand');
const DeleteTreeItemCommand = require('./DeleteTreeItemCommand');
const PasteTreeItemCommand = require('./PasteTreeItemCommand');
const SetHeaderSectionSizeCommand = require('./SetHeaderSectionSizeCommand');
const SetHeaderSectionLevelCommand = require('./SetHeaderSectionLevelCommand');
const CreateHeaderLevelsFromRangeCommand = require('./CreateHeaderLevelsFromRangeCommand');
const SetHeaderSectionOutlineFlagCommand = require('./SetHeaderSectionOutlineFlagCommand');
const CellRange = require('../model/CellRange');
const SheetName = require('../model/SheetName');
const AddSheetNameCommand = require('./AddSheetNameCommand');
const SetSheetNameCommand = require('./SetSheetNameCommand');
const DeleteSheetNameCommand = require('./DeleteSheetNameCommand');
const AddLayoutSectionCommand = require('./AddLayoutSectionCommand');
const SetLayoutSectionCommand = require('./SetLayoutSectionCommand');
const DeleteLayoutSectionCommand = require('./DeleteLayoutSectionCommand');
const SetCellLevelsCommand = require('./SetCellLevelsCommand');
const MarkCellValuesCommand = require('./MarkCellValuesCommand');
const ZoomChartCommand = require('./ZoomChartCommand');
const {
	UpdateSheetNamesCommand,
	SetGraphItemsCommand
} = require('./UpdateNamesCommands');

const Registry = {
	'command.UpdateSheetNamesCommand': UpdateSheetNamesCommand,
	'command.SetGraphItemsCommand': SetGraphItemsCommand,
	'command.SetPlotDataCommand': SetPlotDataCommand,
	'command.SetChartFormulaCommand': SetChartFormulaCommand,
	'command.SetSheetCellsCommand': SetSheetCellsCommand,
	'command.SetCellsCommand': SetCellsCommand,
	'command.SetTreeDataCommand': SetTreeDataCommand,
	'command.SetTreeItemDataCommand': SetTreeItemDataCommand,
	'command.SetTreeItemDepthCommand': SetTreeItemDepthCommand,
	'command.SetTreeItemDisabledCommand': SetTreeItemDisabledCommand,
	'command.SetTreeShowDepthCommand': SetTreeShowDepthCommand,
	'command.SetTreeItemShowDepthCommand': SetTreeItemShowDepthCommand,
	'command.SetTreeItemExpandFlagCommand': SetTreeItemExpandFlagCommand,
	'command.SetTreeItemCheckedFlagCommand': SetTreeItemCheckedFlagCommand,
	'command.AddTreeItemCommand': AddTreeItemCommand,
	'command.DeleteTreeItemCommand': DeleteTreeItemCommand,
	'command.PasteTreeItemCommand': PasteTreeItemCommand,
	'command.SetHeaderSectionSizeCommand': SetHeaderSectionSizeCommand,
	'command.SetHeaderSectionLevelCommand': SetHeaderSectionLevelCommand,
	'command.CreateHeaderLevelsFromRangeCommand': CreateHeaderLevelsFromRangeCommand,
	'command.SetHeaderSectionOutlineFlagCommand': SetHeaderSectionOutlineFlagCommand,
	'command.CellRange': CellRange,
	'command.SheetName': SheetName,
	'command.AddSheetNameCommand': AddSheetNameCommand,
	'command.SetSheetNameCommand': SetSheetNameCommand,
	'command.DeleteSheetNameCommand': DeleteSheetNameCommand,
	'command.AddLayoutSectionCommand': AddLayoutSectionCommand,
	'command.SetLayoutSectionCommand': SetLayoutSectionCommand,
	'command.DeleteLayoutSectionCommand': DeleteLayoutSectionCommand,
	'command.SetCellLevelsCommand': SetCellLevelsCommand,
	'command.MarkCellValuesCommand': MarkCellValuesCommand,
	'command.ZoomChartCommand': ZoomChartCommand
};
class SheetCommandFactory {
	// extends CommandFactory {
	// viewer optional
	static createCommand(graph, data, viewer) {
		const cmd = data ? Registry[data.name] : undefined;
		return cmd
			? cmd.createFromObject(data, { graph, viewer, factory: this })
			: CommandFactory.createCommand.bind(SheetCommandFactory)(graph, data, viewer);
	}
	static create(cmdname, ...args) {
		const Cmd = Registry[cmdname];
		// return Cmd ? new Cmd(...args) : CommandFactory.create(cmdname, ...args);
		if (Cmd) return new Cmd(...args);
		if (cmdname === 'command.MarkCellValuesCommand')
			return MarkCellValuesCommand.fromItemCellRefMap(...args);
		return CommandFactory.create(cmdname, ...args);
	}

	static reduce(cmd) {
		return cmd;
	}
}
// ENABLE SERVER_COMMANDS:
module.exports = require('./server/ServerCommandFactory')(SheetCommandFactory);
// module.exports = SheetCommandFactory;
